/**
 * Qlik object types enabled into ObjectDrawer
 */
export const enabledTypes = {
  "barchart": true,
  "combochart": true,
  "filterpane": true,
  "gauge": true,
  "kpi": true,
  "linechart": true,
  "pivot-table": true,
  "piechart": true,
  "scatterplot": true,
  "table": true,
  "text-image": true,
  "treemap": true,
  "map": true,
  "container": true
}

/**
 * Qlik fields name
 */
export const qlikFields = {
  date: "Date",
  dateN1: "Date_N1",
  group: "Groupe",
  account: "Compte"
}

export const QlikDateFormat = 'dd/MM/yyyy'

/**
 * Qlik fields to hide into current selection display (filters)
 */
export const hiddenSelectionFields = {
  // [qlikFields.date]: true,
  // [qlikFields.dateN1]: true
}